import { AfterViewInit, Directive, ElementRef, Inject, Input } from '@angular/core';
import { SCREEN_LAYOUT, ScreenLayout } from '../layout/layout.provider';

@Directive({
    selector: '[appAutofocus]',
    standalone: false
})
export class AutofocusDirective implements AfterViewInit {
  @Input() enableAutofocusOnMobile = false;

  constructor(private host: ElementRef, @Inject(SCREEN_LAYOUT) public layout: ScreenLayout) {}

  ngAfterViewInit() {
    if (this.layout === 'mobile' && !this.enableAutofocusOnMobile) {
      return;
    }

    this.host.nativeElement.focus();
  }
}
